import { Loader2 } from "lucide-react";

interface LoadingProps {
  message?: string;
  className?: string;
}

export const Loading: React.FC<LoadingProps> = ({
  message = "Loading...",
  className = "",
}) => (
  <div className={`flex items-center justify-center py-8 ${className}`}>
    <Loader2 className="h-8 w-8 animate-spin text-primary" />
    <span className="ml-2 text-gray-600">{message}</span>
  </div>
);